import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { UnloadingInfo } from '../types';
import { tableFilters } from './tableFilters';
import styles from './UnloadingListTable.module.scss';

type UnloadingListTableProps = {
  data?: UnloadingInfo[];
  isLoading?: boolean;
};

const UnloadingListTable: FC<UnloadingListTableProps> = ({
  data,
  isLoading,
}) => {
  const tableColumns = getTableColumns(data);

  return (
    <div className={styles.unloadingListTable}>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        filterDisplay="menu"
      />
    </div>
  );
};

export default UnloadingListTable;
